import { reportGqlError, request, useMutation } from '../../api'
import { gql } from 'graphql-request'
import {
  GeneratePaddleCheckoutUrlFunctionResult,
  GeneratePaddleCustomerPortalSessionUrlFunctionResult,
} from './logic'

export function useGeneratePaddleCheckoutUrl() {
  return useMutation(
    async (dto: {
      priceId: string
    }): Promise<{
      generatePaddleCheckoutUrl?: GeneratePaddleCheckoutUrlFunctionResult
    }> => {
      return request(
        gql`
          mutation ($priceId: String!) {
            generatePaddleCheckoutUrl(priceId: $priceId) {
              code
              message
              hostedCheckoutUrl
            }
          }
        `,
        dto,
      )
    },
    {
      onError: reportGqlError,
    },
  )
}

export function useGeneratePaddleCustomerPortalSessionUrl() {
  return useMutation(
    async (dto: {
      referenceId: string
    }): Promise<{
      generatePaddleCustomerPortalSessionUrl?: GeneratePaddleCustomerPortalSessionUrlFunctionResult
    }> => {
      return request(
        gql`
          mutation ($referenceId: String!) {
            generatePaddleCustomerPortalSessionUrl(referenceId: $referenceId) {
              code
              message
              customerPortalSessionsUrl
            }
          }
        `,
        dto,
      )
    },
    {
      onError: reportGqlError,
    },
  )
}

// Для генерації посилань на оплату в нашій адмінці
export function useGeneratePaddleAdminCheckoutUrl() {
  return useMutation(
    async (dto: {
      priceId: string
      businessId: number
      email?: string
    }): Promise<{
      generatePaddleAdminCheckoutUrl?: GeneratePaddleCheckoutUrlFunctionResult
    }> => {
      return request(
        gql`
          mutation ($priceId: String!, $businessId: Int!, $email: String) {
            generatePaddleAdminCheckoutUrl(
              priceId: $priceId
              businessId: $businessId
              email: $email
            ) {
              code
              message
              hostedCheckoutUrl
            }
          }
        `,
        dto,
      )
    },
    {
      onError: reportGqlError,
    },
  )
}
